
// components/Users/UserAutocomplete.tsx
import { Autocomplete, CircularProgress, InputAdornment, TextField, useTheme } from '@mui/material'
import { useState } from 'react'
import { useUserAutocomplete } from '../../api/aws/users/useUserAutcomplete'
import { renderUserOption } from '../Team/renderOptions'

const UserAutocomplete = ({
  value,
  onChange,
  context,
  multiple = false,
  label = 'Select User',
  isDirty = false,
  savingFields,
}) => {
  const theme = useTheme()
  const [inputValue, setInputValue] = useState('')
  const { allUsers, selectedUser, setSelectedUser, isUsersLoading } = useUserAutocomplete(value, multiple)

  const handleSelectUser = (_, newValue) => {
    if (multiple) {
      const newOwnerIds = newValue.map(user => user.id)
      setSelectedUser(newValue)
      onChange(context, newOwnerIds)
    } else {
      setSelectedUser(newValue)
      onChange(context, newValue ? [newValue.id] : [])
    }
  }

  if (isUsersLoading) {
    return <CircularProgress />
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={allUsers || []}
      getOptionLabel={option =>
        option.real_name ||
        `${option.firstName || option.first_name} ${option.lastName || option.last_name} (${option.email})`
      }
      value={selectedUser}
      onChange={handleSelectUser}
      inputValue={inputValue}
      onInputChange={(_, newVal) => setInputValue(newVal)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterOptions={(options, { inputValue }) =>
        options.filter(option =>
          `${option.firstName || option.first_name} ${option.lastName || option.last_name}`
            .toLowerCase()
            .includes(inputValue.toLowerCase())
        )
      }
      renderOption={(props, option, state) => renderUserOption(props, option, state, theme)}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps, // <-- this keeps the built-in adornments like clear icon
            endAdornment: (
              <>
                {savingFields.includes(context) && (
                  <InputAdornment position="end">
                    <CircularProgress size={16} thickness={5} sx={{ mr: 1 }} />
                  </InputAdornment>
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      fullWidth
      sx={{
        '& .MuiInputBase-root': {
          bgcolor: isDirty ? theme.palette.text.dirty : theme.palette.background.input,
        },
      }}
    />
  )
}

export default UserAutocomplete
